/* eslint-disable max-len */

import {
  Snackbar, Alert,
} from '@mui/material';
import { InputNumber } from 'antd';
import { CommonModal, ErrorBar, Upload } from '@components';
import { useRef, useState } from 'react';
import { uploadFile } from '@api';
import { logError } from '@log';
import classes from './reason-dialog.module.css';

const MAX_UPLOAD_FILE_SIZE = 20;
const MAX_UPLOAD_FILE_NUM = 10;
const ALLOWED_UPLOAD_TYPE = ['.jpg', '.jpeg', '.png'];

const MODAL_TITLE = {
  radio: '1. Please choose the number of damaged items received',
  upload: '2. Please upload clear photo(s) of how the item(s) are damaged.',
  remark: '3. Add additional comments (optional)',
};
const helpText = 'Accepts .gif, .jpg, and .png';
const FailedToastText = `Maximum upload file size: ${MAX_UPLOAD_FILE_SIZE}MB, ${MAX_UPLOAD_FILE_NUM} files at most.`;

export const ReasonDialog = ({
  open, selectedDhgateItems, handleClose, handleOK, currentItem = {},
}) => {
  const info = selectedDhgateItems[currentItem.lineItemId] || {};
  const [quantity, setQuantity] = useState(info.quantity || 0);
  const [comments, setComments] = useState(info.comment);
  const [files1, setFiles1] = useState(info.files1 || []);
  const [files2, setFiles2] = useState(info.files2 || []);
  const [files3, setFiles3] = useState(info.files3 || []);
  const [showToast, setShowToast] = useState(false);
  const [toastText, setToastText] = useState('');
  const [showFailedToast, setShowFailedToast] = useState(false);
  const [failedToastText, setFailedToastText] = useState('');
  const [isDisabled, setIsDisabled] = useState(true);
  const filesName = {
    1: files1,
    2: files2,
    3: files3,
  };
  const filesFunc = {
    1: setFiles1,
    2: setFiles2,
    3: setFiles3,
  };
  const inputValue = useRef(null);
  // 当前所有选择文件的总大小（单位：Byte）
  const currentSize = files1.reduce((sumSize, curFile) => sumSize + curFile.size, 0);
  const isLoading = Object.values(filesName).flat().findIndex((item) => item.isLoading) > -1;
  const onCloseToast = () => {
    setShowToast(false);
  };

  const onCloseFailedToast = () => {
    setShowFailedToast(false);
  };

  const upload = async (fileList, originFiles) => {
    try {
      if (!fileList.length) {
        return [];
      }
      const filePathList = await uploadFile([...fileList]);
      if (!filePathList) {
        return [];
      }
      const resultFiles = [];
      filePathList.forEach((path, index) => {
        resultFiles[index] = {
          id: originFiles[index].id,
          path,
        };
      });
      return resultFiles;
    } catch (error) {
      logError(error);
      return [];
    }
  };

  const handleChange = async (event, number) => {
    try {
      const fileList = event.target.files;
      if (!fileList?.length) {
        return;
      }
      // 限制上传文件数量
      if (filesName[number].length + fileList.length > MAX_UPLOAD_FILE_NUM) {
        setToastText(FailedToastText);
        setShowToast(true);
        inputValue.current.value = '';
        return;
      }
      // 限制上传文件大小
      const fileSize = Array.prototype.slice.call(fileList)
        .reduce((sumSize, curFile) => sumSize + curFile.size, 0);
      if (fileSize + currentSize > MAX_UPLOAD_FILE_SIZE * 1024 * 1024) {
        setToastText(FailedToastText);
        setShowToast(true);
        inputValue.current.value = '';
        return;
      }

      setShowToast(false);
      // 添加文件到文件列表
      const newFiles = [];
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < fileList.length; i++) {
        newFiles.push({
          id: Date.now() + fileList[i].name,
          originalFileName: fileList[i].name,
          name: fileList[i].name,
          path: '',
          isLoading: true,
        });
      }
      filesFunc[number]([...filesName[number], ...newFiles]);

      // 上传文件
      const resultList = await upload(fileList, newFiles);
      // 上传文件失败，从文件列表中删除刚上传的文件
      if (!resultList?.length) {
        filesFunc[number]([...filesName[number]]);
        setFailedToastText(`Failed to upload ${newFiles.map((item) => item.originalFileName).join('; ')}. Please try again.`);
        setShowFailedToast(true);
        inputValue.current.value = '';
        return;
      }

      // 上传成功，更新文件列表
      filesFunc[number]((preFiles) => preFiles.map((file) => {
        const resultFile = resultList.find((item) => item.id === file.id);
        if (!resultFile) {
          return { ...file };
        }
        return { ...file, path: resultFile.path, isLoading: false };
      }));

      /** 防止第二次上传相同文件失效 */
      inputValue.current.value = '';
    } catch (error) {
      console.log(error);
      setFailedToastText('upload files error');
      setShowFailedToast(true);
    }

    setIsDisabled(false);
  };

  const deleteFile = (index, number) => {
    filesName[number].splice(index, 1);
    filesFunc[number]([...filesName[number]]);
  };
  const onChange = (e) => {
    setQuantity(e);
    setIsDisabled(false);
  };
  const onCommentsChange = (e) => {
    setComments(e.target.value);
    setIsDisabled(false);
  };
  const close = () => {
    handleClose();
  };
  // const total = currentItem.actualPrice?.match(/[\d.]+/g)[0]; // 当前要选择的item金额

  // 上传完毕后，continue才能点击
  // const currentFiles = [...files1, ...files2, ...files3].filter((item) => !item.isLoading);
  // 弹窗未修改，continue按钮disabled
  // const isDisabled = (!quantity || (total >= LIMIT_AMOUNT && currentFiles?.length < 2)) || (info === quantity && info.comment === comments && compareFiles([...files1, ...files2, ...files3], reasonFiles));
  // console.log(quantity, total, LIMIT_AMOUNT);
  const attachments = [...files1, ...files2, ...files3].map((file) => ({ originalFileName: file.name, fileLink: file.path }));
  return (
    <CommonModal
      open={open}
      title=" Tell us more about the issue"
      handleClose={close}
      continueDisabled={isDisabled || !quantity || isLoading || !files1.length || !files2.length}
      handleOK={() => handleOK({
        comment: comments, quantity, files1, files2, files3, attachments,
      })}
    >
      <div className={classes.content}>
        <div className={classes.subTitle}>{MODAL_TITLE.radio}</div>
        <InputNumber
          value={quantity}
          defaultValue={0}
          min={0}
          max={currentItem.maxQuantity}
          formatter={(value) => `${value} / ${currentItem.maxQuantity}`}
          parser={(value) => value.replace(` / ${currentItem.maxQuantity}`, '')}
          onChange={(e) => onChange(e, currentItem)}
          style={{ width: '100%' }}
        />
        <div className={classes.divider}></div>
        <div className={classes.subTitle}>{MODAL_TITLE.upload}</div>
        <section className={classes.upload_content}>
          <section className={classes.upload}>
            <span className={classes.red}>*</span>
            Please provide a closeup of the damaged part and one that shows the overall condition.
            <Upload
              files={files1}
              accept={ALLOWED_UPLOAD_TYPE}
              inputValue={inputValue}
              handleChange={(e) => handleChange(e, 1)}
              deleteFile={(v) => deleteFile(v, 1)}
              style={{
                boxShadow: 'initial', width: '250px', padding: 0,
              }}
            >
              <span>{helpText}</span>
            </Upload>
          </section>
          <section className={classes.upload}>
            <span className={classes.red}>*</span>
            Photos of carrier packaging
            <Upload
              files={files2}
              accept={ALLOWED_UPLOAD_TYPE}
              inputValue={inputValue}
              handleChange={(e) => handleChange(e, 2)}
              deleteFile={(v) => deleteFile(v, 2)}
              style={{
                boxShadow: 'initial', width: '250px', padding: 0,
              }}
            >
              <span>{helpText}</span>
            </Upload>
          </section>
          <section className={classes.upload}>

            Others (e.g., photos of internal product packaging if applicable, screenshots of tracking page, etc.)
            <Upload
              files={files3}
              accept={ALLOWED_UPLOAD_TYPE}
              inputValue={inputValue}
              handleChange={(e) => handleChange(e, 3)}
              deleteFile={(v) => deleteFile(v, 3)}
              style={{
                boxShadow: 'initial', width: '250px', padding: 0,
              }}
            >
              <span>{helpText}</span>
            </Upload>
          </section>
        </section>

        {/* 提示 toast */}
        {showToast ? (
          <ErrorBar className={classes.error} message={toastText} canClose onClose={onCloseToast} />
        ) : null}
        <div className={classes.divider}></div>
        <div className={classes.subTitle}>
          {MODAL_TITLE.remark}
        </div>
        <textarea
          rows={2}
          className={classes.input_comments}
          onChange={onCommentsChange}
          value={comments || ''}
          maxLength="300"
        >
        </textarea>
        <div className={classes.comments_tips}> Max 300 characters</div>
      </div>

      {showFailedToast ? (
        <Snackbar
          className={classes.bottom_toast}
          open={showFailedToast}
          anchorOrigin={{
            horizontal: 'center',
            vertical: 'bottom',
          }}
          autoHideDuration={3000}
          onClose={onCloseFailedToast}
        >
          <Alert
            icon={false}
            severity="error"
            className={classes.failed_toast}
            onClose={onCloseFailedToast}
          >
            {failedToastText}
          </Alert>
        </Snackbar>
      ) : null}
    </CommonModal>
  );
};
